export function getSourcedProfileListPath(userType) {
  if (userType === 'Admin') return '/Requirments';
  if (userType === 'TeamLead') return '/TLHome';
  return '/home';
}

export function buildSourcedProfileDeepLink(userType, requirementId, profileId, options = {}) {
  const basePath = options.listPath || getSourcedProfileListPath(userType);
  const params = new URLSearchParams();
  if (requirementId) params.set('requirementId', String(requirementId));
  if (profileId) params.set('profileId', String(profileId));
  if (userType !== 'Admin' && userType !== 'TeamLead') {
    params.set('tab', options.tab || 'claimed');
  }
  const query = params.toString();
  return query ? `${basePath}?${query}` : basePath;
}

/** Resolve navigation path for bell notifications (reuses profile deep-link params). */
export function resolveNotificationNavigationPath(notification, userType) {
  if (!notification) return '';

  if (notification.type === 'status_remark') {
    const requirementId = notification.requirementId
      || parseQueryParam(notification.link, 'requirementId');
    const profileId = notification.candidateId
      || notification.profileId
      || parseQueryParam(notification.link, 'profileId')
      || parseQueryParam(notification.link, 'candidateId');

    if (requirementId && profileId) {
      return buildSourcedProfileDeepLink(userType, requirementId, profileId);
    }
  }

  return notification.link || '';
}

function parseQueryParam(link, key) {
  if (!link || !key) return '';
  const queryIndex = link.indexOf('?');
  if (queryIndex < 0) return '';
  const params = new URLSearchParams(link.slice(queryIndex + 1));
  return params.get(key) || '';
}
